const appInfo = {
    title: 'Федеральный центр мониторинга питания обучающихся'
};
export default appInfo;

